import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Form, Select, DatePicker, Spin, Table } from "antd";
import { getGender } from "../../redux/actions/gender.action";
import { ReadCookie } from "../../utils/readCookie";
import numeral from "numeral";
import moment from "moment";
import logo from "../../assets/images/logo.png";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import pdf from "../../assets/images/PDF_file_icon.svg.png";
import "../ProducList/productList.css";
import { TabTitle } from "../../utils/GeneralFunction.js";
import { useDownloadExcel } from "react-export-table-to-excel";
import { getAllActiveRegion, getAllActiveSaleperson } from "../../redux/actions/getAllActive.js";
import { getGenderCategory } from "../../redux/actions/genderCategory.action.js";
import { loadShipVia } from "../../redux/actions/shipVia.js";
import { getVendorCategory } from "../../redux/actions/vendorCategory.action.js";
import { getBillFormData } from "../../redux/actions/bill.action.js";
import { getDlBill } from "../../redux/actions/dlBill.action.js";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
const XLSX = require("xlsx");

const DLBill = ({ token }) => {
  TabTitle("DL-Bill")
  const { gender, genderCategory, ShipVia, billFormData, dlBill } = useSelector((state) => state);
  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;
  const [loading, setLoading] = useState(false);
  const tableRef = useRef(null);


  const { onDownload: onDownloadReport1 } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "DL-Bill",
    sheet: "Sheet 1",
  });

  const groupedData = dlBill?.payload?.data.reduce((acc, item) => {
    if (!acc[item.vendor_name]) {
      acc[item.vendor_name] = [];
    }
    acc[item.vendor_name].push(item);
    return acc;
  }, {});


  const columns = [
    {
      title: "S #",
      width: 50,
      render: (text, record, index) => {
        return index + 1
      },
    },
    {
      title: "Gender",
      dataIndex: "gender_name",
      key: "gender_name",
      width: 120,
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.gender_name.localeCompare(b.gender_name)
      },
    },
    {
      title: "Gender Category",
      dataIndex: "gender_category_name",
      key: "gender_category_name",
      width: 180,
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.gender_category_name.localeCompare(b.gender_category_name)
      },
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      width: 120,
      align: "right",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.quantity !== null) & (b.quantity !== null)) {
          return a.quantity - b.quantity;
        }
      },
    },
    {
      title: "FOB Amount",
      dataIndex: "gross_amount",
      key: "gross_amount",
      width: 140,
      align: "right",
      render: (text, record) => {
        return (
          <>
            ${text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.gross_amount !== null) & (b.gross_amount !== null)) {
          return a.gross_amount - b.gross_amount;
        }
      },
    },
    {
      title: "FOB Rate",
      dataIndex: "fob_rate",
      key: "fob_rate",
      width: 140,
      align: "right",
      render: (text, record) => {
        return (
          <>
            ${text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.fob_rate !== null) & (b.fob_rate !== null)) {
          return a.fob_rate - b.fob_rate;
        }
      },
    },
    {
      title: "Freight Amount",
      dataIndex: "avg_f_amount",
      key: "avg_f_amount",
      width: 140,
      align: "right",
      render: (text, record) => {
        return (
          <>
            ${text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.avg_f_amount !== null) & (b.avg_f_amount !== null)) {
          return a.avg_f_amount - b.avg_f_amount;
        }
      },
    },
    {
      title: "Freight Rate",
      dataIndex: "f_rate",
      key: "f_rate",
      width: 140,
      align: "right",
      render: (text, record) => {
        return (
          <>
            ${text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.f_rate !== null) & (b.f_rate !== null)) {
          return a.f_rate - b.f_rate;
        }
      },
    },
    {
      title: "Duty Amount",
      dataIndex: "avg_d_amount",
      key: "avg_d_amount",
      width: 140,
      align: "right",
      render: (text, record) => {
        return (
          <>
            ${text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.avg_d_amount !== null) & (b.avg_d_amount !== null)) {
          return a.avg_d_amount - b.avg_d_amount;
        }
      },
    },
    {
      title: "Duty Rate",
      dataIndex: "d_rate",
      key: "d_rate",
      width: 140,
      align: "right",
      render: (text, record) => {
        return (
          <>
            ${text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.d_rate !== null) & (b.d_rate !== null)) {
          return a.d_rate - b.d_rate;
        }
      },
    },
    {
      title: "LDP Amount",
      dataIndex: "ldpamount",
      key: "ldpamount",
      width: 140,
      align: "right",
      render: (text, record) => {
        return (
          <>
            ${text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.ldpamount !== null) & (b.ldpamount !== null)) {
          return a.ldpamount - b.ldpamount;
        }
      },
    },
    {
      title: "LDP Rate",
      dataIndex: "ldp_rate",
      key: "ldp_rate",
      width: 140,
      align: "right",
      render: (text, record) => {
        return (
          <>
            ${text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.ldp_rate !== null) & (b.ldp_rate !== null)) {
          return a.ldp_rate - b.ldp_rate;
        }
      },
    },
    {
      title: "Ship Via",
      dataIndex: "ship_via_description",
      key: "ship_via_description",
      width: 120,
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.ship_via_description.localeCompare(b.ship_via_description)
      },
    },
  ];


  useEffect(() => {
    dispatch(getAllActiveSaleperson(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getGenderCategory(token, menuId));
    dispatch(getAllActiveRegion(token, menuId));
    dispatch(loadShipVia(token));
    dispatch(getVendorCategory(token));
    dispatch(getBillFormData(token));
  }, []);

  const onFinish = async () => {
    await form.validateFields().then((values) => {
      setLoading(true)
      dispatch(getDlBill(token, values)).then((res) => {
        setLoading(false)
      });
    })
  }

  const handlePrint = () => {
    const css = '@page { margin-top: 25px; margin-bottom: 25px; margin-right: 17px}';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style);
  };



  function generatePDF(groupedData) {
    const doc = new jsPDF({ orientation: "landscape" });
    let yOffset = 10;

    Object.entries(groupedData).forEach(([vendor, data], vendorIndex) => {
      if (!Array.isArray(data)) {
        console.warn(`Skipping vendor ${vendor}: data is not array`, data);
        return;
      }

      // Calculate space and decide whether to add page
      if (vendorIndex > 0) {
        const pageHeight = doc.internal.pageSize.getHeight();
        const nextStartY = (doc.lastAutoTable?.finalY || yOffset) + 15;

        if (nextStartY > pageHeight - 20) {
          doc.addPage();
          yOffset = 10;
        } else {
          yOffset = nextStartY;
        }
      }

      // Draw vendor title once per vendor (first page only)
      doc.setFontSize(10);
      doc.text(`${vendor}`, 4, yOffset);
      yOffset += 5;

      const head = [[
        "#",
        "Gender",
        "Gender Category",
        "Quantity",
        "FOB Amount",
        "FOB Rate",
        "Freight Amount",
        "Freight Rate",
        "Duty Amount",
        "Duty Rate",
        "LDP Amount",
        "LDP Rate",
        "Ship Via"
      ]];

      const rows = data.map((item, index) => [
        index + 1,
        item.gender_name,
        item.gender_category_name,
        item.quantity,
        `$${parseFloat(item.gross_amount || 0).toFixed(2)}`,
        `$${parseFloat(item.fob_rate || 0).toFixed(2)}`,
        `$${parseFloat(item.avg_f_amount || 0).toFixed(2)}`,
        `$${parseFloat(item.f_rate || 0).toFixed(2)}`,
        `$${parseFloat(item.avg_d_amount || 0).toFixed(2)}`,
        `$${parseFloat(item.d_rate || 0).toFixed(2)}`,
        `$${parseFloat(item.ldpamount || 0).toFixed(2)}`,
        `$${parseFloat(item.ldp_rate || 0).toFixed(2)}`,
        item.ship_via_description
      ]);

      const totalQty = data.reduce((sum, i) => sum + parseFloat(i.quantity || 0), 0);
      const totalFob = data.reduce((sum, i) => sum + parseFloat(i.gross_amount || 0), 0);
      const totalFreight = data.reduce((sum, i) => sum + parseFloat(i.avg_f_amount || 0), 0);
      const totalDuty = data.reduce((sum, i) => sum + parseFloat(i.avg_d_amount || 0), 0);
      const totalLdp = data.reduce((sum, i) => sum + parseFloat(i.ldpamount || 0), 0);

      rows.push([
        "", "", "Total",
        totalQty,
        `$${totalFob.toFixed(2)}`,
        "",
        `$${totalFreight.toFixed(2)}`,
        "",
        `$${totalDuty.toFixed(2)}`,
        "",
        `$${totalLdp.toFixed(2)}`,
        ""
      ]);

      doc.autoTable({
        startY: yOffset, // ⬅️ Custom start for first page only
        margin: { top: 5, bottom: 4, left: 4, right: 4 }, // ⬅️ Used for continuation pages
        head: head,
        body: rows,
        styles: {
          fontSize: 6,
          lineWidth: 0.1,
          lineColor: [180, 180, 180],
          overflow: 'linebreak',
          fillColor: [255, 255, 255]
        },
        headStyles: {
          fillColor: [224, 230, 237],
          textColor: [0, 0, 0],
          fontStyle: 'bold',
          valign: 'middle',
          fontSize: 6.5
        },
        alternateRowStyles: {
          fillColor: [255, 255, 255]
        },
        bodyStyles: {
          fillColor: [255, 255, 255]
        },
        columnStyles: {
          0: { halign: 'center' },
          1: { halign: 'left' },
          2: { halign: 'left' },
          3: { halign: 'right' },
          4: { halign: 'right' },
          5: { halign: 'right' },
          6: { halign: 'right' },
          7: { halign: 'right' },
          8: { halign: 'right' },
          9: { halign: 'right' },
          10: { halign: 'right' },
          11: { halign: 'right' },
          12: { halign: 'left' }
        },
        didParseCell: function (data) {
          const rightAlignedHeaderIndexes = [3, 4, 5, 6, 7, 8, 9, 10, 11];

          if (data.section === 'head' && rightAlignedHeaderIndexes.includes(data.column.index)) {
            data.cell.styles.halign = 'right';
          }

          if (data.row.index === rows.length - 1 && data.section === 'body') {
            data.cell.styles.fontStyle = 'bold';
          }
        }
      });

      // Update yOffset for next vendor
      yOffset = (doc.lastAutoTable?.finalY || yOffset) + 10;
    });

    doc.save("DL_Bill.pdf");
  }

  function generateExcel(groupedData) {
    const workbook = XLSX.utils.book_new();

    Object.entries(groupedData).forEach(([vendor, data]) => {
      const rows = [];

      // Header row
      rows.push([
        "#",
        "Gender",
        "Gender Category",
        "Quantity",
        "FOB Amount",
        "FOB Rate",
        "Freight Amount",
        "Freight Rate",
        "Duty Amount",
        "Duty Rate",
        "LDP Amount",
        "LDP Rate",
        "Ship Via"
      ]);

      // Data rows
      data.forEach((item, index) => {
        rows.push([
          index + 1,
          item.gender_name,
          item.gender_category_name,
          item.quantity,
          parseFloat(item.gross_amount || 0),
          parseFloat(item.fob_rate || 0),
          parseFloat(item.avg_f_amount || 0),
          parseFloat(item.f_rate || 0),
          parseFloat(item.avg_d_amount || 0),
          parseFloat(item.d_rate || 0),
          parseFloat(item.ldpamount || 0),
          parseFloat(item.ldp_rate || 0),
          item.ship_via_description
        ]);
      });

      // Totals row
      const totalQty = data.reduce((sum, i) => sum + parseFloat(i.quantity || 0), 0);
      const totalFob = data.reduce((sum, i) => sum + parseFloat(i.gross_amount || 0), 0);
      const totalFreight = data.reduce((sum, i) => sum + parseFloat(i.avg_f_amount || 0), 0);
      const totalDuty = data.reduce((sum, i) => sum + parseFloat(i.avg_d_amount || 0), 0);
      const totalLdp = data.reduce((sum, i) => sum + parseFloat(i.ldpamount || 0), 0);

      rows.push([
        "",
        "",
        "Total",
        totalQty,
        totalFob,
        "",
        totalFreight,
        "",
        totalDuty,
        "",
        totalLdp,
        "",
        ""
      ]);

      // Convert rows to worksheet and add to workbook
      const worksheet = XLSX.utils.aoa_to_sheet(rows);
      XLSX.utils.book_append_sheet(workbook, worksheet, vendor.substring(0, 31)); // Sheet name max 31 chars
    });

    XLSX.writeFile(workbook, "DL_Bill.xlsx");
  }









  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="report-wrapper-main header_class">
              <div className="row justify-content-between business_class_oms distributor distributor2">
                <div className="col-3 d-flex align-items-start box-space">
                  <div className="logobrand">
                    <img id="ImgLogo" alt="logo" src={logo} />
                  </div>
                </div>

                <div className="col-4 box-space right-content-header text-right">
                  <div className=" d-flex justify-content-end">
                    <div className=" d-flex justify-content-end mr-8 printing_class">
                      <div className="print_icon printing_class">
                        <i
                          onClick={handlePrint}
                          id="Image1"
                          title="Print"
                          alt="Print"
                          // src={btnPrint}
                          className="fa-solid fa-print"
                        ></i>
                      </div>
                      <div className="print_icon printing_class">
                        <input
                          type="image"
                          name="ImgExcel"
                          alt="Export to excel"
                          id="ImgExcel"
                          title="Export to excel"
                          src={xlsx}
                          onClick={(e) => {
                            generateExcel(groupedData)
                          }}
                          style={{ borderWidth: "0px", height: "14px" }}
                        />
                      </div>
                      <div className="print_icon printing_class">
                        <input
                          type="image"
                          name="ImgPDF"
                          alt="Export to PDF"
                          id="ImgPDF"
                          title="Export to PDF"
                          src={pdf}
                          onClick={(e) => {
                            e.preventDefault();
                            generatePDF(groupedData);
                          }}
                          style={{ borderWidth: "0px", height: "18px" }}
                        />
                      </div>
                    </div>
                    <span style={{ fontSize: "small", fontWeight: "bolder" }}>
                      DL Bill Data
                      <br />
                      Rpt # 489
                      <br />
                      <p className=" mb-0">Rpt # 001_V4</p>
                      Login as:{" "}
                      <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                        {userName}
                      </span>
                      <br />
                    </span>
                  </div>
                </div>
              </div>
              <div className="row pb-2">
                <div className="col">
                  <Form
                    layout="horizontal"
                    form={form}
                    name="control-hooks"
                    onFinish={onFinish}
                  >
                    <div className="main_form row">
                      <hr className="my-1" />
                      <div className="col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="gender_id" className="labels width30">
                            From Date:
                          </label>
                          <div className=" w-100">
                            <Form.Item
                              name="from_date"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 24 }}
                              initialValue={moment().startOf('year')}
                            >
                              <DatePicker
                                format={"MM-DD-YYYY"}
                                size='small'
                                className="styleInput w-100"
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className=" col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="gender_id" className="labels width30">
                            To Date
                          </label>
                          <div className=" w-100">
                            <Form.Item
                              name="to_date"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 24 }}
                              initialValue={moment().endOf('year')}
                            >
                              <DatePicker
                                size='small'
                                className="styleInput w-100"
                                format={"MM-DD-YYYY"}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className=" col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label className="labels width30">Gender:</label>
                          <div className="w-100">
                            <Form.Item
                              name="gender"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 24 }}
                              initialValue={"All"}
                            >
                              <Select
                                size='small'
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, options) => options.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                className="styleInput w-100"
                              >
                                <Option value={null}>All</Option>
                                {
                                  gender?.payload?.data.map((val) => {
                                    return (
                                      <Option key={val.gender_id} value={val.gender_id}>{val.gender_name}</Option>
                                    )
                                  })
                                }
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className=" col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label className="labels width30">G Category:</label>
                          <div className="w-100">
                            <Form.Item
                              initialValue={"All"}
                              name="gender_category_id"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 24 }}
                            >
                              <Select
                                className={"select_Inputs"}
                                showSearch
                                optionFilterProp="children"
                                size="small"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                              >
                                <Option value={null}>All</Option>
                                {genderCategory &&
                                  genderCategory?.payload?.data.map((it, index) => {
                                    return (
                                      <Option
                                        key={index}
                                        value={it.gender_category_id}
                                      >
                                        {it.gender_category_name}
                                      </Option>
                                    );
                                  })}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className=" col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label className="labels width30">Ship Via:</label>
                          <div className="w-100">
                            <Form.Item
                              initialValue={"All"}
                              name="shipVia"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 24 }}
                            >
                              <Select
                                size="small"
                                className={"select_Inputs"}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, options) =>
                                  options.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                filterSort={(optionA, optionB) =>
                                  optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                }
                              >
                                <Option value={null}>All</Option>
                                {ShipVia?.payload?.data.map((ship) => {
                                  return (
                                    <Option
                                      key={ship.courier_service_id}
                                      value={ship.courier_service_id}
                                    >
                                      {ship.service_name}
                                    </Option>
                                  );
                                })}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className=" col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label className="labels width30">Vendor:</label>
                          <div className="w-100">
                            <Form.Item
                              initialValue={"All"}
                              name="vendor"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 24 }}
                            >
                              <Select
                                size="small"
                                className={"select_Inputs"}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, options) =>
                                  options.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                filterSort={(optionA, optionB) =>
                                  optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                }
                                loading={billFormData?.loading}
                              >
                                <Option value={null}>All</Option>
                                {billFormData?.payload?.vendor.map((item) => {
                                  return (
                                    <Option
                                      key={item.vendor_id}
                                      value={item.vendor_id}
                                    >
                                      {item.vendor_name}
                                    </Option>
                                  );
                                })}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div style={{ marginTop: "3px", display: "flex", justifyContent: "right" }} >
                          <Button type="primary" htmlType="submit" className='submit-btn-btm m-0' disabled={loading}>
                            Search
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="table_content"
        style={{ width: 'fit-content' }}
        ref={tableRef}
      >
        <div>
          {loading ? (
            <div className="d-flex align-items-center justify-content-center spin-style mt-3">
              <Spin />
            </div>
          ) : dlBill?.payload?.data.length ? (
            Object.entries(groupedData).map(([vendor, data]) => (
              <div key={vendor} style={{ marginBottom: '40px' }}>
                <h3 style={{ borderBottom: "1px solid black", paddingBottom: "1px", display: "inline-block", marginBottom: "15px" }}>{vendor}</h3>
                <Table
                  style={{ fontSize: '10.3px' }}
                  className="border-line-th bottom-align-th table-td-border-right th-general-style td-general-style border omsTable"
                  size="small"
                  pagination={false}
                  summary={pageData => {
                    let qty = pageData.reduce(function (previousValue, currentValue) {
                      return previousValue += parseFloat(currentValue.quantity)
                    }, 0);
                    let fobAmount = pageData.reduce(function (previousValue, currentValue) {
                      return previousValue += parseFloat(currentValue.gross_amount)
                    }, 0);
                    let freightAmount = pageData.reduce(function (previousValue, currentValue) {
                      return previousValue += parseFloat(currentValue.avg_f_amount)
                    }, 0);
                    let dutyAmount = pageData.reduce(function (previousValue, currentValue) {
                      return previousValue += parseFloat(currentValue.avg_d_amount)
                    }, 0);
                    let ldpAmount = pageData.reduce(function (previousValue, currentValue) {
                      return previousValue += parseFloat(currentValue.ldpamount)
                    }, 0);
                    return (
                      <>
                        <Table.Summary.Row>
                          <Table.Summary.Cell>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right" }}>Total:</p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              {numeral(qty.toLocaleString("en-US")).format("0,00")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              ${numeral(fobAmount.toLocaleString("en-US")).format("0,00.00")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              ${numeral(freightAmount.toLocaleString("en-US")).format("0,00.00")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              ${numeral(dutyAmount.toLocaleString("en-US")).format("0,00.00")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell className="sales_table_summary">
                            <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                              ${numeral(ldpAmount.toLocaleString("en-US")).format("0,00.00")}
                            </p>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      </>
                    );
                  }}
                  bordered
                  columns={columns}
                  scroll={{ x: 'max-content' }}
                  dataSource={data}
                />
              </div>
            ))
          ) : (
            <div
              style={{
                backgroundColor: '#CCCCCC',
                borderWidth: '1pt',
                borderStyle: 'Dashed',
                fontWeight: 'bold',
                height: '25px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              No record(s)
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DLBill;
